import React from 'react';
import { Link } from 'react-router-dom';
import { IoIosCafe } from "react-icons/io";
import { FiArrowLeft } from "react-icons/fi";
import '../styles/PrivacyPolicy.css';

function PrivacyPolicy() {
  return (
    <div className="privacy-container">
      <header className="privacy-header">
        <Link to="/" className="privacy-back-link">
          <FiArrowLeft className="privacy-back-icon" />
          Back to Home
        </Link>
        <h1 className="privacy-brand">
          <IoIosCafe className="privacy-brand-icon" />
          Cappuccino
        </h1>
      </header>

      <main className="privacy-main">
        <div className="privacy-hero">
          <h1 className="privacy-title">Privacy Policy</h1>
          <p className="privacy-date">Last Updated: November 9, 2025</p>
        </div>

        <div className="privacy-content">
          <section className="privacy-section">
            <h2>Introduction</h2>
            <p>
              Cappuccino is a Chrome browser extension that helps venture capital professionals discover and evaluate startup founders on LinkedIn. This Privacy Policy explains how we collect, use, and protect your information.
            </p>
          </section>

          <section className="privacy-section">
            <h2>Information We Collect</h2>

            <h3>Account Information</h3>
            <p>When you create an account, we collect your email address, password (encrypted), VC firm name, and investment thesis.</p>

            <h3>LinkedIn Profile Data</h3>
            <p>We temporarily analyze publicly available LinkedIn profiles you search for, including names, job titles, work history, and education. We only save evaluation summaries and match scores—not complete profile data.</p>

            <h3>Search & Usage Data</h3>
            <p>We store your search queries, results, settings, and optionally your Salesforce connection status. We also collect basic usage data to improve the service.</p>
          </section>

          <section className="privacy-section">
            <h2>How We Use Your Information</h2>
            <p>We use your information to:</p>
            <ul>
              <li>Authenticate your account and provide search functionality</li>
              <li>Evaluate founder-thesis alignment using AI</li>
              <li>Generate personalized outreach messages</li>
              <li>Sync opportunities to Salesforce (optional)</li>
              <li>Improve our service and debug technical issues</li>
              <li>Send service-related notifications</li>
            </ul>
          </section>

          <section className="privacy-section">
            <h2>Data Storage and Security</h2>

            <h3>Where We Store Data</h3>
            <ul>
              <li><strong>Local Browser:</strong> Temporary settings and cached results</li>
              <li><strong>Supabase Database:</strong> User accounts, search history, and results</li>
              <li><strong>Backend Server:</strong> Temporary AI processing (not permanently stored)</li>
            </ul>

            <h3>Security</h3>
            <p>We use HTTPS encryption, secure password hashing via Supabase, and authentication-protected data access.</p>

            <h3>Data Retention</h3>
            <p>We retain your account data while active. Search history is kept until you delete it. Deleted accounts are purged within 30 days.</p>
          </section>

          <section className="privacy-section">
            <h2>Third-Party Services</h2>
            <p>We use the following services:</p>
            <ul>
              <li><strong>Supabase:</strong> Database and authentication</li>
              <li><strong>LinkedIn:</strong> Public profile data source (not affiliated)</li>
              <li><strong>Salesforce:</strong> Optional integration for syncing opportunities</li>
              <li><strong>OpenAI:</strong> AI analysis for founder-thesis matching</li>
              <li><strong>Render.com:</strong> Backend hosting</li>
            </ul>
          </section>

          <section className="privacy-section">
            <h2>Data Sharing</h2>

            <div className="privacy-highlight">
              <strong>We do not sell your data to third parties.</strong>
            </div>

            <p>We only share data with:</p>
            <ul>
              <li>Service providers (Supabase, Render.com, OpenAI) necessary for functionality</li>
              <li>Salesforce, when you choose to connect your account</li>
              <li>Legal authorities, if required by law</li>
            </ul>
          </section>

          <section className="privacy-section">
            <h2>Your Rights</h2>
            <p>You can:</p>
            <ul>
              <li>View and export your search history</li>
              <li>Delete individual searches or your entire account</li>
              <li>Connect or disconnect Salesforce anytime</li>
              <li>Uninstall the extension to stop data collection</li>
            </ul>
          </section>

          <section className="privacy-section">
            <h2>Important Notices</h2>

            <h3>LinkedIn Data</h3>
            <p>This extension analyzes publicly available LinkedIn profiles you search for. We only save evaluation summaries, not complete profiles. We are not affiliated with or endorsed by LinkedIn.</p>

            <h3>Updates to This Policy</h3>
            <p>We may update this policy and will notify you via the extension. Continued use constitutes acceptance of changes.</p>

            <h3>International Users</h3>
            <p>Data may be processed in the United States. By using Cappuccino, you consent to this transfer.</p>
          </section>

          <section className="privacy-section">
            <h2>Contact Us</h2>
            <p>For questions about this Privacy Policy, please contact us at: <strong>justicedxn1@gmail.com</strong></p>
          </section>

          <div className="privacy-divider"></div>

          <p className="privacy-effective">
            This privacy policy is effective as of November 9, 2025.
          </p>
        </div>
      </main>
    </div>
  );
}

export default PrivacyPolicy;
